import {getCsrfHeaders, mainApiHeaders, rootApiUrl} from '../../../../../service/api/api-const';
import {postAndDeserialize, serialize} from '../../../../../util/api-adapter';
import {FetchMethodEnum, fetchNoContent} from '../../../../../util/fetch';

import {
    CompetitorsSummaryStatsRequestType,
    CompetitorsTableRequestOptionsType,
    competitorsTableResponseSchema,
    CompetitorsTableResponseType,
    ExportExcelType,
    summarySchema,
    SummaryType,
} from './competitors-page-type';

export function fetchCompetitorsTable(
    options: CompetitorsTableRequestOptionsType
): Promise<CompetitorsTableResponseType> {
    const url = `/cp/competitors/table/`;

    return postAndDeserialize(url, competitorsTableResponseSchema, options);
}

export function fetchSummary(options: CompetitorsSummaryStatsRequestType): Promise<SummaryType> {
    const url = `/cp/competitors/summary/`;

    return postAndDeserialize(url, summarySchema, options);
}

export async function fetchExportCompetitors(options: ExportExcelType): Promise<void> {
    const url = `${rootApiUrl}/cp/competitors/export/`;

    return fetchNoContent(url, {
        method: FetchMethodEnum.post,
        headers: {...mainApiHeaders, ...getCsrfHeaders()},
        body: JSON.stringify(serialize(options)),
    });
}
